import React, { useState } from 'react';
import moment from 'moment';
import { Alert } from 'antd';
import 'material-icons-font/material-icons-font.css';

import DateRangePicker from 'components/blocks/DateRangePicker';
import GmailCampaignHistoryTable from './GmailCampaignHistoryTable';
import { getGmailCampaignHistory } from '../../../services/gmail';
import { Input, Button, Row, Col } from 'components/ui';
import { Loading } from 'components/blocks';
import './style.css';
import { useFetchActiveCampaignsSummary } from 'query/gmail';

function GmailCampaignHistory() {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [dateRange, setDateRange] = useState(() => ({
    startDate: moment().startOf('month'),
    endDate: moment(),
  }));

  const { data: campaignSummary } = useFetchActiveCampaignsSummary();

  function handleDateRangeChange(dates) {
    setDateRange({ startDate: dates[0], endDate: dates[1] });
  }

  function handleFilterChange(e) {
    setFilter(e.target.value);
  }

  function handleLoadData() {
    setIsLoading(true);
    getGmailCampaignHistory({
      start_date: new Date(dateRange.startDate),
      end_date: new Date(dateRange.endDate),
    })
      .then(v => setData(v))
      .catch(() => setData([]))
      .finally(() => setIsLoading(false));
  }

  return (
    <div className="gmail-ch-container">
      <header>
        <Row>
          <Col>
            <h2>Gmail Campaign History {isLoading && <Loading />}</h2>
          </Col>
        </Row>
      </header>
      <Row>
        <Col span={20}>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            <DateRangePicker
              endDate={dateRange.endDate}
              startDate={dateRange.startDate}
              onDateRangeChange={handleDateRangeChange}
            />
            <div className="gmail-ch-load-button">
              <Button type="button" onClick={handleLoadData}>
                Load Data
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <div className="gmail-ch-panel">
        <div className="gmail-ch-search">
          <i className="material-icons md-24 gmail-ch-icon">search</i>
          <Input
            placeholder="Filter..."
            style={{ border: '0' }}
            value={filter}
            onChange={handleFilterChange}
          />
        </div>
        {!!campaignSummary && !!campaignSummary.queuedEmails && (
          <Alert
            message={`There are currently ${campaignSummary.activeAccounts} active gmail accounts with approximately ${campaignSummary.queuedEmails} emails queued`}
            showIcon
            type="info"
          />
        )}
        <GmailCampaignHistoryTable
          data={data}
          filtered={[{ id: 'all', value: filter }]}
        />
      </div>
    </div>
  );
}

export default GmailCampaignHistory;
